import React from 'react';

import { goloomSdk } from '../../../shared/features/goloom-sdk';

export const useLocalVad = () => {
    const [active, setActive] = React.useState(false);

    React.useEffect(() => {
        const handleLocalVad = (active: boolean) => {
            setActive(active);
        };

        goloomSdk.onLocalVad.addListener(handleLocalVad);

        return () => {
            goloomSdk.onLocalVad.removeListener(handleLocalVad);
        };
    }, []);

    return active;
};
